import {
    NavNotificationBadge,
    usePatientNotificationCounts,
} from "@/features/onboarding/hooks/usePatientNotificationCounts";

const NotificationCount = () => {
    const { diariesBadgeCount } = usePatientNotificationCounts();

    return <NavNotificationBadge count={diariesBadgeCount} />;
};

export default NotificationCount;
